import { MODERN_THEMES } from './modern-themes';
export const THEME_OPTIONS = [{
  key: 'trellis-light',
  displayName: 'Teal',
  themeName: 'trellis',
  themeMode: 'light',
  legacyFallback: 'trellis-light'
}, Object.assign({
  key: 'navy-light',
  displayName: 'Navy'
}, MODERN_THEMES['navy-light'])];